import React, { useRef } from "react";
import { SDrawerOrModal, SLowcodeList } from "shj-components";

import { config } from './config.jsx'
import { productOperationSearchBusinessLog } from "@/services/product.ts";

const LogsModal = (props) => {
  const { open, onClose, record = {} } = props;
  const listRef = useRef();

  const fetchList = ({ query }) => {
    if (!record.id) return Promise.reject()
    return new Promise((resolve, reject) => {
      productOperationSearchBusinessLog({
        businessId: record.id,
        businessType: 'GENERAL_STANDARD_DETAIL',
        ...query,
      }).then(res => {
        resolve({ records: res })
      }).catch(err => {
        reject(err)
      })
    })
  }

  const extension = {
    request: { fetchList },
    rowKey: 'id',
  }

  return <>
    <SDrawerOrModal
      title={'调整记录'}
      width={900}
      open={open}
      loading={false}
      onCancel={onClose}
      antdProps={{
        footer: null
      }}
    >
      <SLowcodeList searchMode={'group'} ref={listRef} config={config} {...extension}/>
    </SDrawerOrModal>
  </>
}

export default LogsModal